// import axios from 'axios';
// import {
//     getAuthHeader
// } from "@/services/user.service.js";


export {
    GetProfessionContribution,
    UpdateProfessionContribution
};

function GetProfessionContribution(contractNumber, versionNumber, onSuccess, onError) {

    // var headers = getAuthHeader();

    console.log(contractNumber);
    console.log(versionNumber);
    console.log(onError);

    var professionContribution = {
        Account: "BB01",
        ShowInRssFeed: true,
        professionContributionContents: [{
                id: 701,
                infoId: 124,
                Documents: `Grundsätzlich reicht pro Kalenderjahr ein Nachweis (z.B. eine Lohnabrechnung oder Bescheinigung des Temporärbüros), 
                
um für ein ganzes Kalenderjahr (12 Monate) die Rückerstattung geltend machen zu können, dies unabhängig davon wie lange der Einsatz gedauert hat. D.h., dass die Rückerstattungsperiode vom 01.01. bis 31.12. erfasst werden muss und die berufliche Tätigkeit ebenfalls.`,
                Remarks: `Bei einem Eintritt in die Unia während des Jahres erfolgt die Rückerstattung pro rata. 
Das Datum „Zeitraum Rückzahlung von“ soll mit dem effektiven Eintritt in die Unia übereinstimmen. Wird ein Mitglied während des Jahres festangestellt, kann trotzdem für das gesamte Kalenderjahr über den Parifonds-Personalverleih abgerechnet werden. Das heisst, das Mitglied bezieht die Rückerstattung des V8153 und hat damit kein Anrecht auf eine eventuelle Auszahlung eines anderen Berufbeitrags für die Zeit bis Ende Jahr. Liste der unterstellten und nicht unterstellten Betriebe ist auf dem Intranet: 

http://intranet.unia.ch/index.php?id=2428&L=0`,
                "language": "de-CH"
            },
            {
                id: 702,
                infoId: 125,
                Documents: "Grundsätzlich reicht pro Kalenderjahr ein Nachweis (z.B. eine Lohnabrechnung oder Bescheinigung des Temporärbüros), um für ein ganzes Kalenderjahr (12 Monate) die Rückerstattung geltend machen zu können, dies unabhängig davon wie lange der Einsatz gedauert hat. D.h., dass die Rückerstattungsperiode vom 01.01. bis 31.12. erfasst werden muss und die berufliche Tätigkeit ebenfalls.",
                Remarks: "Bei einem Eintritt in die Unia während des Jahres erfolgt die Rückerstattung pro rata. Das Datum „Zeitraum Rückzahlung von“ soll mit dem effektiven Eintritt in die Unia übereinstimmen. Wird ein Mitglied während des Jahres festangestellt, kann trotzdem für das gesamte Kalenderjahr über den Parifonds-Personalverleih abgerechnet werden. Das heisst, das Mitglied bezieht die Rückerstattung des V8153 und hat damit kein Anrecht auf eine eventuelle Auszahlung eines anderen Berufbeitrags für die Zeit bis Ende Jahr. Liste der unterstellten und nicht unterstellten Betriebe ist auf dem Intranet: http://intranet.unia.ch/index.php?id=2428&L=0",
                "language": "fr-CH"
            },
            {
                id: 703,
                infoId: 126,
                Documents: "Grundsätzlich reicht pro Kalenderjahr ein Nachweis (z.B. eine Lohnabrechnung oder Bescheinigung des Temporärbüros), um für ein ganzes Kalenderjahr (12 Monate) die Rückerstattung geltend machen zu können, dies unabhängig davon wie lange der Einsatz gedauert hat. D.h., dass die Rückerstattungsperiode vom 01.01. bis 31.12. erfasst werden muss und die berufliche Tätigkeit ebenfalls.",
                Remarks: "Bei einem Eintritt in die Unia während des Jahres erfolgt die Rückerstattung pro rata. Das Datum „Zeitraum Rückzahlung von“ soll mit dem effektiven Eintritt in die Unia übereinstimmen. Wird ein Mitglied während des Jahres festangestellt, kann trotzdem für das gesamte Kalenderjahr über den Parifonds-Personalverleih abgerechnet werden. Das heisst, das Mitglied bezieht die Rückerstattung des V8153 und hat damit kein Anrecht auf eine eventuelle Auszahlung eines anderen Berufbeitrags für die Zeit bis Ende Jahr. Liste der unterstellten und nicht unterstellten Betriebe ist auf dem Intranet: http://intranet.unia.ch/index.php?id=2428&L=0",
                "language": "it-CH"
            }
        ],
        YearylOverviews: [
            {
                Year: "2019",
                Deduction: true
            },
            {
                Year: "2018",
                Deduction: true
            },
            {
                Year: "2017",
                Deduction: false
            },
            {
                Year: "2016",
                Deduction: false
            },
            {
                Year: "2015",
                Deduction: false
            }
        ]
    };

    setTimeout(() => {
        onSuccess(professionContribution);
    }, 1000);

    // axios
    //     .get(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionNumber}/versions`, headers)
    //     .then(response => {
    //         onSuccess(response.data.currentItems);
    //     })
    //     .catch(error => {
    //         onError(error);
    //     });
}

function UpdateProfessionContribution(linkId, onSuccess, onError) {

    // var headers = getAuthHeader();
    console.log(linkId);
    console.log(onSuccess);
    console.log(onError);

    // axios
    //     .get(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionNumber}`, headers)
    //     .then(response => {
    //         onSuccess(response.data.currentItem);
    //     })
    //     .catch(error => {
    //         onError(error);
    //     });
}
